import { TableRow, TableCell } from "@mui/material"
import TooltipIcon from "../TooltipIcon"
import {ResponsiveCell}  from "./ResponsiveCell"

type props = {
    field: string, 
    value?: string, 
    hasCopyOption?: boolean, 
    route?: string, 
    remBorder?: boolean, 
    boldProperty?: boolean,
    helperText?: string,
}

export const Row = ({field, value="", hasCopyOption = false, route, remBorder = false, boldProperty = false, helperText}: props) => {
    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell sx={{border: remBorder? 0 : null, fontWeight: boldProperty? "bolder" : null}} component="th" scope="row">
                <TooltipIcon title={helperText || field}/>
                {field}
            </TableCell>
            {value? <ResponsiveCell remBorder={remBorder} value={value} hasCopyOption={hasCopyOption} route={route}/> : null}
        </TableRow>
    )
}